import { plgRequest } from "plg/api/plgApi";
import type { UnlockKey } from "plg/screens/Unlocks/unlocks";

/** GET /v1/plg/home: the home page copy, kept in Platform_Config PLG_HOME_CONFIG. */
export interface PlgHomeContent {
  browse: { title: string; text: string };
  howItWorks: {
    title: string;
    /** `icon` is a PlgIcon name; `answer` is the popup's paragraphs. */
    tiles: { key: string; label: string; icon: string; line: string; answer: string[] }[];
  };
  gettingStarted: { title: string; steps: { title: string; text: string }[] };
  onceYouHire: { title: string; tiles: { key: UnlockKey; label: string; line: string }[] };
}

/** POST /v1/plg/home/feedback: a Did you find this helpful? answer on a How it works tile, saved in the portal Feedback table. */
export async function postTileFeedback(tile: string, helpful: boolean): Promise<void> {
  const { ok, status } = await plgRequest("POST", "/v1/plg/home/feedback", { tile, helpful });
  if (!ok) throw new Error(`Failed to send feedback: ${status}`);
}

export async function fetchHomeContent(): Promise<PlgHomeContent> {
  const { ok, status, payload } = await plgRequest<PlgHomeContent>("GET", "/v1/plg/home");
  if (!ok) throw new Error(`Failed to load the home page: ${status}`);
  return payload;
}
